import TerritoryModule from '~/lib/vue/modules/territory';

/**
 * @param {~/lib.foundation.Container} services
 * @return {Object}
 */
export default (services, namespace='serviceAddressTerritories') => {
  return TerritoryModule.create({
    namespace,
    services,
  });
};
